export default __webpack_public_path__ + "locales/bg/CreateEditRoomDialog.json?hash=726f3974a1794b1161fae4adb09c79ca";